// extracted by mini-css-extract-plugin
export default {"link":"MenuLink_link__nJ1el","link__destacado":"MenuLink_link__destacado__fl0TI"};